<template>
  <div>
    <div class="tab-text">
      <el-row type="flex" justify="space-around">
        <el-col :span="11">
          <el-form
            ref="form"
            label-width="30%"
            label-position="left"
            size="small"
          >
            <el-form-item :label="$t('tanggal')">
              <DatePicker
                size="small"
                style="width: 100%"
                :shortcuts="$$shortcuts()"
                :format="$formatDate"
                :value="form.tglKeluar"
                type="date"
                placeholder="Select date"
                v-model="form.tglKeluar"
              ></DatePicker>
            </el-form-item>
          </el-form>
        </el-col>

        <el-col :span="11">
          <el-form
            ref="form"
            label-width="30%"
            label-position="left"
            size="small"
          >
            <el-form-item :label="$t('ket')">
              <el-input
                v-model="form.keterangan"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>

    <vs-card style="width: 100%" class="w-full">
      <el-row>
        <el-col>
          <vxe-toolbar size="small">
            <template v-slot:buttons>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-search"
                v-on:click="$refs.exbc.openModal()"
                >{{ $t("pilihExbc") }}</el-button
              >
            </template>

            <template v-slot:tools>
              <el-button
                size="small"
                type="primary"
                icon="el-icon-circle-check"
                :disabled="baca.length <= 0"
                @click.prevent="submitedData"
                >{{ $t("simpan") }}</el-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            size="mini"
            :loading="loadingTable"
            empty-text="Empty Data "
            keep-source
            border
            resizable
            show-footer
            :footer-method="footerMethod"
            ref="xTable"
            height="400"
            :row-style="$$rowStyleDelete"
            row-key
            highlight-hover-row
            highlight-current-row
            :row-config="{ isCurrent: true, isHover: true, height: 35 }"
            :column-config="{ resizable: true }"
            :data="baca"
            :mouse-config="{ selected: true }"
            :checkbox-config="{
              highlight: true,
              range: true,
            }"
            :keyboard-config="{
              isArrow: true,
              isDel: true,
              isEnter: true,
              isTab: true,
              isEdit: true,
            }"
            :edit-config="{
              trigger: 'dblclick',
              mode: 'cell',
              showStatus: true,
            }"
            :scroll-y="{ mode: 'wheel' }"
          >
            <vxe-column type="seq" fixed="left" width="60"></vxe-column>

            <vxe-column width="150" align="center" title="DELETE">
              <template v-slot="{ row }">
                <vxe-button
                  status="danger"
                  v-if="!row.isDeleted"
                  v-on:click="
                    () => {
                      deleteData(row);
                    }
                  "
                  size="mini"
                  >DELETE</vxe-button
                >
                <vxe-button
                  status="warning"
                  v-if="row.isDeleted"
                  v-on:click="
                    () => {
                      deleteData(row);
                    }
                  "
                  size="mini"
                  >CANCEL</vxe-button
                >
              </template>
            </vxe-column>

            <vxe-column
              width="140"
              align="center"
              field="tujuanOut"
              :title="$t('tujuanOut').toUpperCase()"
              header-align="center"
            >
              <template v-slot:default="{ rowIndex, row }">
                <el-button
                  v-on:click="handleOpenModalTujuanOut(rowIndex, row)"
                  size="mini"
                  color="primary"
                  type="primary"
                >
                  {{ $t("pilih").toUpperCase() }}
                </el-button>
              </template>
            </vxe-column>

            <vxe-column
              width="140"
              align="center"
              field="department"
              :title="$t('department').toUpperCase()"
              header-align="center"
            />

            <vxe-column
              width="120"
              align="left"
              header-align="center"
              field="kodeMaterial"
              :title="$t('code').toUpperCase()"
              sortable
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="200"
              align="left"
              header-align="center"
              field="namaMaterial"
              :title="$t('deskripsi').toUpperCase()"
              sortable
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.namaMaterial"
                  size="mini"
                  type="text"
                ></vxe-input>
              </template>

              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>

            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="satuan"
              :title="$t('satuan').toUpperCase()"
            >
            </vxe-column>

            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="style"
              :title="$store.state.styleName"
              v-if="$store.state.availableStyle"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.style"
                  size="mini"
                  type="text"
                ></vxe-input>
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="color"
              :title="$store.state.colorName"
              v-if="$store.state.availableColor"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.color"
                  size="mini"
                  type="text"
                ></vxe-input>
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="size"
              :title="$store.state.sizeName"
              v-if="$store.state.availableSize"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.size"
                  size="mini"
                  type="text"
                ></vxe-input>
              </template>
            </vxe-column>
            <vxe-column
              width="100"
              align="center"
              header-align="center"
              field="spec"
              :title="$store.state.specName"
              v-if="$store.state.availableSpec"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.spec"
                  size="mini"
                  type="text"
                ></vxe-input>
              </template>
            </vxe-column>

            <vxe-column
              width="150"
              align="right"
              header-align="center"
              field="qtyKeluarOk"
              :formatter="$$formatAmountBc"
              :title="$t('qty').toUpperCase()"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.qtyKeluarOk"
                  size="mini"
                  type="number"
                ></vxe-input>
              </template>
            </vxe-column>

            <vxe-column
              width="100"
              align="left"
              header-align="center"
              field="noUrut"
              title="CUSTOMS DOC"
              sortable
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
            </vxe-column>
          </vxe-table>
        </el-col>
      </el-row>
    </vs-card>

    <SelectExbc ref="exbc" @sendData="selectExbc" />
    <vxe-modal
      resize
      v-model="openModalTujuanOut"
      width="auto"
      height="auto"
      esc-closable
      title="TUJUAN OUT MODAL"
    >
      <el-button
        type="danger"
        icon="el-icon-refresh"
        @click="setDeptValue(null)"
      >
        Reset Department
      </el-button>
      <el-divider />
      <el-button
        icon="el-icon-check"
        v-for="(item, index) in loopTujuanOut"
        @click="setDeptValue(item.namaProses)"
        :key="index"
      >
        {{ item.namaProses }}
      </el-button>
    </vxe-modal>
    <br />
  </div>
</template>

<script>
import SelectExbc from "../../components/other/SelectExbc.vue";
export default {
  components: {
    SelectExbc,
  },
  data() {
    return {
      optionsSatuan: [],
      optionsCurrency: [],
      loopTujuanOut: [],
      loadingTable: false,
      getRowClicked: {},
      openModalTujuanOut: false,
      selectIndex: null,
      loadingTableTambahan: false,
      form: {
        tglKeluar: new Date(),

        keterangan: null,
      },
      baca: [],
    };
  },

  methods: {
    setDeptValue(namaProses) {
      const selectedRow = this.baca.find(
        (f) => f._X_ROW_KEY === this.getRowClicked._X_ROW_KEY
      );

      selectedRow.department = namaProses || null;

      this.openModalTujuanOut = false;

      this.$notify({
        offset: 200,
        title: "SUCCESS",
        message: namaProses
          ? `Departement row ${
              this.getRowClicked.rowIndex + 1
            } changed to ${namaProses}`
          : `Departement row ${
              this.getRowClicked.rowIndex + 1
            } has been cleared`,
        type: "success",
      });
    },

    handleOpenModalTujuanOut(rowIndex, row) {
      this.getRowClicked = row;
      this.getRowClicked.rowIndex = rowIndex;
      this.openModalTujuanOut = true;
    },
    async getLoopTujuanOutData() {
      const url = "api/v1/masterdata/proses";
      const res = await this.$api.get(url);
      this.loopTujuanOut = res.data;
    },
    selectExbc(row) {
      let newElm = { ...row };
      let find = this.baca.find((f) => f.idAsal === row.id);

      if (find) {
        return this.notifValidasi("Data ini sudah terpilih", true);
      }

      newElm.idAsal = newElm.id;
      newElm.kodeMaterial = newElm.kodeBarang;
      newElm.namaMaterial = newElm.namaBarang;
      newElm.satuan = newElm.satuan;
      newElm.qtyKeluarOk = newElm.qtyInputWh - newElm.qtyOutWh;

      this.baca.push(newElm);

      this.$notify({
        offset: 200,
        title: "SUCCESS",
        message: `Material ${newElm.namaMaterial} telah berhasil dipilih.`,
        type: "success",
      });

      delete newElm.id;
    },
    rowStyle({ row }) {
      if (row.isDeleted == true) {
        return {
          backgroundColor: "red",
          color: "white",
        };
      }
    },
    deleteData(data) {
      if (data.id) {
        if (data.isDeleted) {
          data.isDeleted = false;
          return;
        }
        if (!data.isDeleted) {
          data.isDeleted = true;
          return;
        }
      }

      if (!data.id) {
        this.baca = this.baca.filter((f) => f._X_ROW_KEY != data._X_ROW_KEY);
      }
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (["qty", "price", "amount"].includes(column.property)) {
            data.forEach((e) => {
              e.amount = e.qty * e.price;
            });
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    setFormValue(data) {
      if (data.tglKeluar) {
        data.tglKeluar = new Date(data.tglKeluar);
      }
      this.baca = data.listDetail;
    },

    async submitedData() {
      try {
        this.form["listDetail"] = this.baca;

        this.$emit("submitedData", this.form);
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.loading({ text: "error:Hubungi developer" });
        console.log(error);
      }
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
  },

  mounted() {
    this.getLoopTujuanOutData();
  },
};
</script>

<style>
.tengah {
  text-align: center;
  color: rgb(115, 103, 240);
}
#container {
  position: relative;
  width: 600px;
  height: 400px;
}
</style>
<style src="vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css" />
